var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.table)?_c('div',{staticClass:"table"},[_c('breadcrumb',{attrs:{"items":[{title: _vm.title.text, to: _vm.$route.path}]}}),_c('page',_vm._b({key:_vm.tableId},'page',{defsEndpoint: _vm.defsEndpoint, title: _vm.title},false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }